export async function hashPassword(password: string): Promise<string> {
    const utf8 = new TextEncoder().encode(process.env.CRYPTO_SALT + password);
    return await crypto.subtle.digest("SHA-256", utf8).then((hashBuffer) => {
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray
            .map((bytes) => bytes.toString(16).padStart(2, "0"))
            .join("");
    });
}
export function getCookie(name: string) {
    let cookieValue;
    if (document.cookie && document.cookie !== '') {
        let cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export function setCookie(name: string, value: string, date: string) {
    document.cookie = document.cookie + `${name}=${value}; expires=${date}; path=/`;
}